/**
 * Envelope types of the endpoint text messages that carry annotations. The
 * desktop app's overlay (meet-hour-electron-sdk/screensharing/annotation.js)
 * speaks the same format: { type, payload }.
 */
export const ANNOTATION_MESSAGE = 'annotation';
export const POINTER_MESSAGE = 'pointer';

/**
 * Presence property a sharer sets to 'true' to turn viewer drawing off.
 */
export const ANNOTATION_OFF_PROPERTY = 'annotationOff';

/**
 * Message the page posts to itself for the desktop app's preload, which owns
 * the sharer's on-screen overlay: { type, allowed, clear }.
 */
export const DESKTOP_BRIDGE_MESSAGE = 'mh-remote-annotation';

/**
 * A stroke stays for STROKE_HOLD_MS, then fades out over STROKE_FADE_MS - the
 * desktop overlay's auto-erase timing, so both ends lose a stroke together.
 */
export const STROKE_HOLD_MS = 2200;
export const STROKE_FADE_MS = 900;

/**
 * A remote pointer (dot + name) disappears this long after its last update.
 */
export const POINTER_TIMEOUT_MS = 3000;

/**
 * How often a drawing viewer sends what it drew since the last message.
 */
export const SEND_INTERVAL_MS = 60;

/**
 * Upper bounds for what one message and the whole stroke store may hold.
 */
export const MAX_POINTS_PER_MESSAGE = 500;
export const MAX_STORED_SEGMENTS = 3000;

/**
 * Stroke color for a participant whose tile color is not known yet.
 */
export const DEFAULT_COLOR = '#1264A3';
